/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein (1-letter)`)
};

const es_translate_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteína (1 letra)`)
};

const de_translate_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein (1-Buchstaben-Code)`)
};

const nl_translate_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiwit (1 letter)`)
};

const fr_translate_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protéine (1 lettre)`)
};

const it_translate_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteina (1 lettera)`)
};

const pt_br2_translate_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteína (1 letra)`)
};

const pt_translate_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteína (1 letra)`)
};

const ja_translate_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タンパク質（1文字表記）`)
};

const zh_translate_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蛋白质（单字母）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_output_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_output_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_output_label", locale)
	if (locale === "en") return en_translate_output_label(inputs)
	if (locale === "es") return es_translate_output_label(inputs)
	if (locale === "de") return de_translate_output_label(inputs)
	if (locale === "nl") return nl_translate_output_label(inputs)
	if (locale === "fr") return fr_translate_output_label(inputs)
	if (locale === "it") return it_translate_output_label(inputs)
	if (locale === "pt-BR") return pt_br2_translate_output_label(inputs)
	if (locale === "pt") return pt_translate_output_label(inputs)
	if (locale === "ja") return ja_translate_output_label(inputs)
	return zh_translate_output_label(inputs)
};